import { Stop, Close, CheckCircle } from "@mui/icons-material";
import React, { memo, useEffect } from "react";

import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable }) => {
  return (
    <div
      style={{
        backgroundColor: "#FFF5F5",
        padding: "8px",
        borderRadius: "8px",
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 3px 5px",
        border: "1px solid rgba(239, 68, 68, 0.25)",
      }}
    >
      <div
        style={{
          color: "#ededed",
          fontSize: "16px",
          flexDirection: "row",
          display: "flex",
        }}
      >
        <Stop
          sx={{
            width: "16px",
            height: "16px",
            marginRight: "4px",
            marginTop: "4px",
            color: "#ef4444",
          }}
        />
        <div style={{ color: "#232323", fontSize: "16px" }}>
          Finalizar atendimento
        </div>
      </div>
      <div style={{ color: "#727272", fontSize: "12px" }}>
        Este bloco finaliza o atendimento e fecha o ticket!
      </div>
      <div
        style={{
          color: "#dc2626",
          fontSize: "11px",
          marginTop: "4px",
          fontStyle: "italic",
        }}
      >
        {/* 💡 Cliente pode digitar "0" para fechar a conversa */}
      </div>
      <Handle
        type="target"
        position="left"
        id="a"
        style={{
          background: "#ef4444",
          width: "18px",
          height: "18px",
          top: "70%",
          left: "-11px",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      >
        <Close
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none",
          }}
        />
      </Handle>
    </div>
  );
});
